"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PairingClaimResponse = exports.PairingClaimInput = exports.PairingInitResponse = exports.PairingInitInput = void 0;
const zod_1 = require("zod");
const player_schema_js_1 = require("./player.schema.js");
const manifest_schema_js_1 = require("./manifest.schema.js");
exports.PairingInitInput = zod_1.z.object({
    display_name: zod_1.z.string().min(1).max(128),
    group_id: zod_1.z.string().uuid().nullable(),
});
exports.PairingInitResponse = zod_1.z.object({
    player_id: zod_1.z.string().uuid(),
    pairing_code: zod_1.z.string().regex(/^[A-Z0-9]{6}$/),
    expires_in_seconds: zod_1.z.number().int().positive(),
});
exports.PairingClaimInput = zod_1.z.object({
    code: zod_1.z.string().regex(/^[A-Z0-9]{6}$/),
    hardware_profile: player_schema_js_1.HardwareProfile,
});
exports.PairingClaimResponse = zod_1.z.object({
    device_jwt: zod_1.z.string().min(20),
    refresh_token: zod_1.z.string().min(20),
    player_id: zod_1.z.string().uuid(),
    signing_public_keys: zod_1.z.array(manifest_schema_js_1.PublicKeyEntry).min(1),
});
//# sourceMappingURL=pairing.schema.js.map